import { useEffect, useState } from 'react'

import { GetViewState, SaveViewState } from './DL/ViewState'


/**
 * Igual que useState, pero el valor se conserva mientras dure la sesión: si el usuario va a otra
 * página y regresa, la vista recupera lo último que tenía (por ejemplo, el texto de búsqueda o el
 * orden de una tabla). El valor debe poder convertirse a JSON.
 *
 * @param {string|null} key - Nombre del dato. Si es null, no se conserva nada y funciona como useState.
 * @param {*} initialValue - Valor inicial cuando todavía no hay nada guardado.
 * @returns {[*, Function]} Igual que useState: [valor, función para cambiarlo].
 */
const usePersistedState = (key, initialValue) => {
    const [value, setValue] = useState(() => (key ? GetViewState(key, initialValue) : initialValue))

    useEffect(() => {
        if (key) SaveViewState(key, value)
    }, [key, value])

    return [value, setValue]
}

export { usePersistedState }
